import { Autocomplete } from '@primer/react';
import * as React from 'react';
export default {
  Autocomplete,
  React
};